import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  projectMinistry,
  projectScheme,
  projectMultiLocation,
  projectSingleLocation,
  issueState,
  issueStatus,
  projectStatus,
  schemeProject,
  fetchProjectReport,
  activeReport,
  fetchFlatFileReport,
  clearSelectedStateValue,
  fetchMeetingValue
} from "../../actions/mis.action";
import PropTypes from "prop-types";
import { toggleSidebar } from "../../actions/common.action";
import {
  getDownloadDecisionReportsAction,
  getDownloadWeeklyReportAction,
  getDownloadUserDetails,
  getDownloadIssueWithCommentsReportsAction
} from "../../actions/dowloadExcelActions";
import { MisDropDownOptions, SideBarMenuTemplate } from "../reusableComponent";
import submenuIcon from "../../assets/icon-submenu.png";
import { setLocalstorage } from "../../helper";

import { isValidArray } from "../../helper";
//import {clearSelectedStateValue} from "../../actions/mis.action";

class MisSidebar extends Component {
  state = {
    dropDown: MisDropDownOptions,
    selectedTab: "STATE_SUMMARY"
  };

  componentDidMount() {
    // const {clearSelectedStateValue, selectedState} = this.props;
    let stateDropdown = this.state.dropDown;
    let newDropdown =
      stateDropdown &&
      stateDropdown.map(item => {
        if (item.title !== "State Profile") {
          item.expandView = false;
        }
        return item;
      });
    this.setState(
      {
        dropDown: newDropdown
      },
      () => {
        const { selectedTab } = this.state;
        const { activeReport } = this.props;
        activeReport(selectedTab);
      }
    );
    setLocalstorage("misPageChanged", false);
  }

  toggleSidebar = () => {
    const { toggleSideBarDispatch } = this.props;
    toggleSideBarDispatch();
  };

  handleSidebar = e => {
    const {
      dataset: { index }
    } = e.target;

    // in case of nodal officer
    this.setState(prevState => {
      // expand view
      prevState.dropDown[index]["expandView"] = !prevState.dropDown[index][
        "expandView"
      ];

      return {
        dropDown: prevState.dropDown,
        selectedTab: prevState.selectedTab
      };
    });
    setLocalstorage("filters", null);
    setLocalstorage("projectSummaryFilters", null);
  };

  handleReport = e => {
    const {
      dataset: { view }
    } = e.target;
    const {
      clearSelectedStateValue,
      selectedState,
      fetchMeetingValue
    } = this.props;
    const { selectedTab } = this.state;
    const prevSelectedTab = selectedTab;
    if (prevSelectedTab === view) {
      setLocalstorage("misPageChanged", false);
      return;
    }
    this.setState({ selectedTab: view });
    this.callReportBy(view);
    setLocalstorage("filters", null);
    setLocalstorage("projectSummaryFilters", null);
    setLocalstorage("misPageChanged", true);
    localStorage.removeItem("monitoring");
    localStorage.removeItem("meetingType");
    clearSelectedStateValue(selectedState.value);
    const meeting = {
      label: "Cabinet Secretariat",
      name: "Cabinet Secretariat",
      optionName: "Cabinet Secretariat",
      value: "Cabinet Secretariat"
    };
    fetchMeetingValue(meeting);
  };

  callReportBy = async view => {
    const {
      fetchProjectReport,
      issueState,
      fetchFlatFileReport,
      projectMinistry,
      activeReport,
      projectSingleLocation,
      projectScheme,
      schemeProject
    } = this.props;
    const data = { limit: 10, offset: 0 };
    await activeReport(view);

    switch (view) {
      case "PROJECT_SUMMARY":
        await fetchProjectReport();
        break;

      case "MINISTRY_REPORT":
        await projectScheme(data);
        break;
      case "MINISTRY_COMPLIANCE":
        await projectScheme(data);
        break;
      case "SCHEME_REPORT":
        await schemeProject();
        break;

      case "LOCATION_REPORT":
        await projectSingleLocation();
        break;

      case "MINISTRY_ISSUES":
        await projectMinistry();
        break;

      case "ISSUE_STATE":
        await issueState();
        break;

      case "FLAT_FILE":
        await fetchFlatFileReport();
        break;

      default:
        break;
    }
  };

  onDownloadIssues = async (type, view) => {
    const {
      activeReport,
      weeklyReportReducer,
      getDownloadIssueWithCommentsReportsDispatch,
      getDownloadDecisionReportsDispatch,
      getDownloadWeeklyReportDispatch,
      getDownloadUserDetailsDispatch
    } = this.props;

    view &&
      this.setState({
        selectedTab: type
      });

    await activeReport(view);

    switch (type) {
      case "comment":
        getDownloadIssueWithCommentsReportsDispatch();
        break;

      case "decision":
        getDownloadDecisionReportsDispatch();
        break;

      case "userDetails":
        getDownloadUserDetailsDispatch();
        break;

      case "weeklyReport":
        !weeklyReportReducer.isLoading && getDownloadWeeklyReportDispatch();
        break;

      default:
        break;
    }
  };

  render() {
    const { toggleSideBar } = this.props;
    const { dropDown, selectedTab } = this.state;
    const active = (window.innerWidth > 991 && !toggleSideBar) || toggleSideBar;

    return (
      <React.Fragment>
        <div
          className={`sidebar-inner-list ${
            active ? `sidebar-transition` : `show-less`
          }`}
        >
          <div
            className={`${
              !active
                ? `toggled-btn-sidebar sidebar-toggle-btn`
                : "sidebar-toggle-btn"
            }`}
          >
            <i className={`${!active ? `hide-sidebar` : "left-arrow"}`} />
            <div className="toggle" onClick={this.toggleSidebar}>
              <span />
              <span />
              <span />
            </div>
          </div>
          <div className="sidebar-menu">
            <div className="menu-list">
              <SideBarMenuTemplate
                containerClasses="mis-project-menu"
                options={dropDown}
                headerTemplate={({ index, title, view, icon, expandView }) => (
                  <div
                    className="heading"
                    data-index={index}
                    data-view={view}
                    onClick={this.handleSidebar}
                  >
                    {title === "State Profile" ? (
                      <img
                        src={icon}
                        width={24}
                        height={24}
                        data-view={view}
                        alt="icon"
                        style={{ marginRight: "-7.05px" }}
                      />
                    ) : (
                      <img
                        src={icon}
                        width={16}
                        height={16}
                        data-view={view}
                        alt="icon"
                      />
                    )}

                    <span
                      data-view={view}
                      data-index={index}
                      className="mis-sidebar-title"
                    >
                      {title}
                    </span>
                  </div>
                )}
                subMenuTemplate={({ index, title, view, downloadBy }) => {
                  return !downloadBy ? (
                    <div
                      data-title={title}
                      data-view={view}
                      className={`submenu ${
                        selectedTab === view ? "active" : ""
                      }`}
                      onClick={this.handleReport}
                    >
                      <img
                        src={submenuIcon}
                        data-view={view}
                        alt="icon"
                        height={8}
                        width={8}
                      />
                      <span data-view={view} className="submenu-title">
                        {title}
                      </span>
                    </div>
                  ) : (
                    <div
                      data-title={title}
                      data-view={view}
                      className={`submenu ${
                        selectedTab === downloadBy ? "active" : ""
                      }`}
                      onClick={this.onDownloadIssues.bind(
                        this,
                        downloadBy,
                        view
                      )}
                    >
                      {title}
                    </div>
                  );
                }}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

MisSidebar.propTypes = {
  toggleSideBar: PropTypes.bool
};

MisSidebar.defaultProps = {
  toggleSideBar: false
};

function mapStateToProps(state) {
  return {
    toggleSideBar: state.commonReducer.toggleSideBar,
    selectedState: state.misReducer.selectedState,
    weeklyReportReducer: state.donwloadExcelReducer.weeklyReport
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleSideBarDispatch: toggleSidebar,
      projectMinistry: projectMinistry,
      projectScheme: projectScheme,
      projectMultiLocation: projectMultiLocation,
      projectSingleLocation: projectSingleLocation,
      issueState: issueState,
      issueStatus: issueStatus,
      projectStatus: projectStatus,
      schemeProject: schemeProject,
      fetchProjectReport: fetchProjectReport,
      activeReport: activeReport,
      fetchFlatFileReport: fetchFlatFileReport,
      getDownloadUserDetailsDispatch: getDownloadUserDetails,
      getDownloadWeeklyReportDispatch: getDownloadWeeklyReportAction,
      getDownloadIssueWithCommentsReportsDispatch: getDownloadIssueWithCommentsReportsAction,
      getDownloadDecisionReportsDispatch: getDownloadDecisionReportsAction,
      clearSelectedStateValue: clearSelectedStateValue,
      fetchMeetingValue: fetchMeetingValue
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MisSidebar);
